<template>
  <div>
    <button class="hamburger-btn" @click="toggleMobileSidebar">
      <i class="fas fa-bars"></i>
    </button>

    <div
      class="sidebar-overlay"
      :class="{ active: mobileSidebarOpen }"
      @click="mobileSidebarOpen = false"
    ></div>

    <div
      class="sidebar"
      :class="{ 'mobile-open': mobileSidebarOpen }"
      :dir="locale"
    >
      <div class="sidebar-wrapper">


        <div class="sidebar-menu">
          <div v-if="!permissionsReady" class="px-3 py-2 text-muted small">
            Loading...
          </div>

          <ul v-else class="nav flex-column">
            <!-- Dashboard -->
            <!-- <li class="nav-item" v-if="showDashboardMenu">
              <router-link
                class="nav-link"
                :to="dashboardRoute"
                :class="{ active: $route.path === dashboardRoute }"
                @click="mobileSidebarOpen = false"
              >
                <i class="fas fa-tachometer-alt"></i>
                <span class="menu-text ms-1">{{ $t("sidebar.dashboard") }}</span>
              </router-link>
            </li> -->

            <!-- In your sidebar component, add this section for super admin -->
<!-- ===================== Super Admin ===================== -->
<template v-if="isSuperAdmin">
  <li class="nav-item">
    <router-link
      class="nav-link"
      :to="{ name: 'tenants.index' }"
      :class="{ active: $route.name?.startsWith('tenants') }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-database"></i>
      <span class="menu-text ms-1">{{ $t("sidebar.databaseManagement") }}</span>
    </router-link>
  </li>
</template>


            <!-- ===================== School Admin ===================== -->
            <template v-if="isSchoolAdmin || isSuperAdmin ">
               <li class="nav-item" v-if="can('statistics.display')">
    <router-link
      class="nav-link"
      :to="{ name: 'statistics' }"
      :class="{ active: $route.name === 'statistics' }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-chart-bar"></i>
      <span class="menu-text ms-1">{{ $t("sidebar.statistics") }}</span>
    </router-link>
  </li>

  <li class="nav-item" v-if="showDashboardMenu">
    <router-link
      class="nav-link"
      :to="dashboardRoute"
      :class="{ active: $route.path === dashboardRoute }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-tachometer-alt"></i>
      <span class="menu-text ms-1">{{ $t('sidebar.dashboard') }}</span>
    </router-link>
  </li>

              <li class="nav-item" v-if="isSchoolAdmin">
                <router-link
                  class="nav-link"
                  :to="{ name: 'subscription.my' }"
                  :class="{ active: $route.name === 'subscription.my' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-id-card-clip"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.mySubscription") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('users.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'users' }"
                  :class="{ active: $route.name === 'users.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-users"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.users") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('classes.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'classes.index' }"
                  :class="{ active: $route.name === 'classes.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-chalkboard-teacher"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.classes") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('students.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'students.index' }"
                  :class="{ active: $route.name === 'students.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-user-graduate"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.students") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('teachers.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'teachers.index' }"
                  :class="{ active: $route.name === 'teachers.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-person-chalkboard"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.teachers") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('employees.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'employees.index' }"
                  :class="{ active: $route.name === 'employees.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-user-tie"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.employees") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('teacher_lessons.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'teacher-lessons.index' }"
                  :class="{ active: $route.name === 'teacher-lessons.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-chalkboard-user"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.teacher_lessons") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('guardians.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'guardians.index' }"
                  :class="{ active: $route.name === 'guardians.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-hands-holding-child"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.guardians") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('subjects.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'subjects.index' }"
                  :class="{ active: $route.name === 'subjects.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-book-open"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.subjects") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('exam_gate_schedules.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'exams.management' }"
                  :class="{ active: $route.name === 'exam-schedules.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar-days"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.exams") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('assignments.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'assignments.index' }"
                  :class="{ active: $route.name === 'assignments.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-tasks"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.assignments") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('grade_sheets.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'grade-sheets.index' }"
                  :class="{ active: $route.name === 'grade-sheets.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-file-alt"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.grades") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('buses.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'buses.index' }"
                  :class="{ active: $route.name === 'buses.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-bus"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.buses") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('announcements.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'announcements.index' }"
                  :class="{ active: $route.name === 'announcements.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-bullhorn"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.announcements") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="showPostsMenu">
                <router-link
                  class="nav-link"
                  :to="{ name: 'posts.index' }"
                  :class="{ active: $route.name?.startsWith('posts') }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-newspaper"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.posts") }}</span>
                </router-link>
              </li>
<li class="nav-item" >
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>

              <!-- Reward Points Dropdown -->
              <div class="nav-item" v-if="hasAny(['student_rewards.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('rewards') }"
                  href="#"
                  @click.prevent="toggleMenu('rewards')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-star ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.reward_points") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'rewards' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'rewards' }">
                  <router-link
                    v-if="can('student_rewards.display')"
                    :to="{ name: 'student-rewards.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'student-rewards.index' }"
                  >
                    <i class="fas fa-star me-1"></i>
                    {{ $t("sidebar.student_points") }}
                  </router-link>

                  <router-link
                    v-if="can('student_rewards.display')"
                    :to="{ name: 'student-rewards.statistics' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'student-rewards.statistics' }"
                  >
                    <i class="fas fa-chart-bar me-1"></i>
                    {{ $t("sidebar.statistics_chart") }}
                  </router-link>
                </div>
              </div>

              <!-- Canteen Dropdown -->
              <div class="nav-item" v-if="hasAny(['canteen_transactions.display', 'canteen_products.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('canteen') }"
                  href="#"
                  @click.prevent="toggleMenu('canteen')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-utensils ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.canteen") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'canteen' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'canteen' }">
                  <router-link
                    v-if="can('canteen_transactions.display')"
                    :to="{ name: 'canteen.dashboard' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'canteen.dashboard' }"
                  >
                    <i class="fas fa-cash-register me-1"></i>
                    {{ $t("canteen.management") }}
                  </router-link>

                  <router-link
                    v-if="can('canteen_products.display')"
                    :to="{ name: 'canteen.products' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('canteen.products') }"
                  >
                    <i class="fas fa-box me-1"></i>
                    {{ $t("canteen.products") }}
                  </router-link>
                </div>
              </div>

              <!-- Attendance Dropdown -->
              <div class="nav-item" v-if="hasAny(['student_attendance.display', 'teacher_attendance.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('attendance') }"
                  href="#"
                  @click.prevent="toggleMenu('attendance')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-calendar-check ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.attendance") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'attendance' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'attendance' }">
                  <router-link
                    v-if="can('student_attendance.display')"
                    to="/attendances"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-user-graduate me-1"></i>
                    {{ $t("sidebar.student_attendance") }}
                  </router-link>

                  <router-link
                    v-if="can('teacher_attendance.display')"
                    to="/teacher-attendances"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-chalkboard-teacher me-1"></i>
                    {{ $t("sidebar.teacher_attendance") }}
                  </router-link>
                </div>
              </div>

              <!-- Questions Dropdown -->
              <div class="nav-item" v-if="hasAny(['questions.display', 'exam_forms.create'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('questions') }"
                  href="#"
                  @click.prevent="toggleMenu('questions')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-question-circle ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.questions") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'questions' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'questions' }">
                  <router-link
                    v-if="can('questions.display')"
                    :to="{ name: 'questions.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('questions') }"
                  >
                    <i class="fas fa-list me-1"></i>
                    {{ $t("sidebar.questions_bank") }}
                  </router-link>

                  <router-link
                    v-if="can('exam_forms.create')"
                    :to="{ name: 'question-forms.create' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('question-forms') }"
                  >
                    <i class="fas fa-file-alt me-1"></i>
                    {{ $t("sidebar.exam_forms") }}
                  </router-link>
                </div>
              </div>

              <!-- Payments Dropdown -->
              <div
                class="nav-item"
                v-if="hasAny(['class_fees.display', 'financial_settings.display', 'payment_receipts.display', 'financial_statements.display'])"
              >
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('payments') }"
                  href="#"
                  @click.prevent="toggleMenu('payments')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-money-bill-wave ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.payments") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'payments' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'payments' }">
                  <router-link
                    v-if="can('class_fees.display')"
                    :to="{ name: 'class-fees.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('class-fees') }"
                  >
                    <i class="fas fa-list-ul me-1"></i>
                    {{ $t("sidebar.payment_structure") }}
                  </router-link>

                  <router-link
                    v-if="can('financial_settings.display')"
                    to="/financial-settings"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-money-bill-wave me-1"></i>
                    {{ $t("sidebar.financial_settings") }}
                  </router-link>

                  <router-link
                    v-if="can('payment_receipts.display')"
                    :to="{ name: 'payment-receipts.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('payment-receipts') }"
                  >
                    <i class="fas fa-exchange-alt me-1"></i>
                    {{ $t("sidebar.payment_transactions") }}
                  </router-link>

                  <router-link
                    v-if="can('financial_statements.display')"
                    class="dropdown-item"
                    :to="{ name: 'financial.statements' }"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-file-invoice-dollar me-1"></i>
                    {{ $t("sidebar.financial_statements") }}
                  </router-link>
                </div>
              </div>

              <!-- Account Statements Dropdown -->
              <div class="nav-item" v-if="can('payment_receipts.display')">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('accountStatements') }"
                  href="#"
                  @click.prevent="toggleMenu('accountStatements')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-file-invoice-dollar ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.account_statements") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'accountStatements' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'accountStatements' }">
                  <router-link
                    :to="{ name: 'reports.guardianAccountStatement' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'reports.guardianAccountStatement' }"
                  >
                    <i class="fas fa-user-friends me-1"></i>
                    {{ $t("sidebar.guardian_account_statement") }}
                  </router-link>

                  <router-link
                    :to="{ name: 'reports.guardianWalletStatement' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'reports.guardianWalletStatement' }"
                  >
                    <i class="fas fa-wallet me-1"></i>
                    {{ $t("sidebar.guardian_wallet_statement") }}
                  </router-link>

                  <router-link
                    :to="{ name: 'reports.studentAccountStatement' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'reports.studentAccountStatement' }"
                  >
                    <i class="fas fa-user-graduate me-1"></i>
                    {{ $t("sidebar.student_account_statement") }}
                  </router-link>

                  <router-link
                    :to="{ name: 'reports.studentWalletStatement' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'reports.studentWalletStatement' }"
                  >
                    <i class="fas fa-wallet me-1"></i>
                    {{ $t("sidebar.student_wallet_statement") }}
                  </router-link>

                </div>
              </div>

              <!-- Salaries Dropdown -->
              <div class="nav-item" v-if="hasAny(['salary_management.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('salaries') }"
                  href="#"
                  @click.prevent="toggleMenu('salaries')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fa-solid fa-sack-dollar ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.salaries") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'salaries' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'salaries' }">
                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.dashboard' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.dashboard' }"
                  >
                    <i class="fa-solid fa-chart-pie me-1"></i>
                    {{ $t("sidebar.salary_dashboard") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.management' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.management' || $route.name === 'salary.receipts' }"
                  >
                    <i class="fa-solid fa-money-check-dollar me-1"></i>
                    {{ $t("sidebar.salary_receipts") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.calculations' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.calculations' || $route.name === 'salary.calculationDetail' }"
                  >
                    <i class="fa-solid fa-calculator me-1"></i>
                    {{ $t("sidebar.salary_calculations") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.statements' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.statements' }"
                  >
                    <i class="fas fa-file-invoice-dollar me-1"></i>
                    {{ $t("sidebar.salary_statements") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.rewardsList' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.rewardsList' || $route.name === 'salaries.createReward' }"
                  >
                    <i class="fas fa-gift me-1"></i>
                    {{ $t("sidebar.salary_rewards") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.deductionsList' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.deductionsList' || $route.name === 'salaries.createDeduction' }"
                  >
                    <i class="fas fa-circle-minus me-1"></i>
                    {{ $t("sidebar.salary_deductions") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.employeeSheet' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.employeeSheet' }"
                  >
                    <i class="fas fa-file-invoice me-1"></i>
                    {{ $t("sidebar.salary_employee_sheet") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.teacherSheet' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.teacherSheet' }"
                  >
                    <i class="fas fa-chalkboard-teacher me-1"></i>
                    {{ $t("sidebar.salary_teacher_sheet") }}
                  </router-link>
                </div>
              </div>

              <!-- Academic Management Dropdown -->
               
              <div class="nav-item" v-if="hasAny(['academic_years.display', 'student_promotion.display', 'promotion_history.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('academic') }"
                  href="#"
                  @click.prevent="toggleMenu('academic')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-graduation-cap ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.academic_management") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'academic' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'academic' }">
                  <router-link
                    v-if="can('academic_years.display')"
                    :to="{ name: 'academic.years' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'academic.years' }"
                  >
                    <i class="fas fa-calendar-alt me-1"></i>
                    {{ $t("sidebar.academic_years") }}
                  </router-link>

                  <router-link
                    v-if="can('student_promotion.display')"
                    :to="{ name: 'academic.promotion' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'academic.promotion' }"
                  >
                    <i class="fas fa-user-graduate me-1"></i>
                    {{ $t("sidebar.student_promotion") }}
                  </router-link>

                  <router-link
                    v-if="can('promotion_history.display')"
                    :to="{ name: 'academic.promotion-history' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'academic.promotion-history' }"
                  >
                    <i class="fas fa-history me-1"></i>
                    {{ $t("sidebar.promotion_history") }}
                  </router-link>
                </div>
              </div>

              <!-- Settings Dropdown -->
              <div
                class="nav-item"
                v-if="hasAny(['nationalities.display','groups.display','chapters.display','exam_types.display','areas.display','reward_points_settings.display','job_titles.display'])"
              >
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('settings') }"
                  href="#"
                  @click.prevent="toggleMenu('settings')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-cog ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("navbar.settings") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'settings' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'settings' }">
                  <router-link
                    v-if="can('nationalities.display')"
                    :to="{ name: 'settings.nationalities.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-flag me-1"></i>
                    {{ $t("sidebar.nationalities") }}
                  </router-link>

                  <router-link
                    v-if="can('groups.display')"
                    to="/groups"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-users me-1"></i>
                    {{ $t("sidebar.groups_management") }}
                  </router-link>

                  <router-link
                    v-if="can('chapters.display')"
                    class="dropdown-item"
                    :to="{ name: 'chapters.index' }"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fa-solid fa-list-ol me-1"></i>
                    {{ $t("sidebar.chapters_management") }}
                  </router-link>

                  <router-link
                    v-if="can('exam_types.display')"
                    :to="{ name: 'settings.exam-types' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'settings.exam-types' }"
                  >
                    <i class="fas fa-tags me-1"></i>
                    {{ $t("sidebar.exam_types") }}
                  </router-link>

                  <router-link
                    v-if="can('areas.display')"
                    to="/settings/areas"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-map-marked-alt me-1"></i>
                    {{ $t("sidebar.areas") }}
                  </router-link>

                  <router-link
                    v-if="can('reward_points_settings.display')"
                    to="/settings/reward-points"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'settings.reward-points.index' }"
                  >
                    <i class="fas fa-star-half-alt me-1"></i>
                    {{ $t("sidebar.reward_points_settings") }}
                  </router-link>

                  <router-link
                    v-if="can('job_titles.display')"
                    :to="{ name: 'job-titles.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'job-titles.index' }"
                  >
                    <i class="fa-solid fa-id-badge me-1"></i>
                    {{ $t("sidebar.job_titles") }}
                  </router-link>
                </div>
              </div>
            </template>

            <!-- ===================== Academic Manager ===================== -->
            <template v-if="isAcademicManager">
           <li class="nav-item" v-if="showDashboardMenu">
    <router-link
      class="nav-link"
      :to="dashboardRoute"
      :class="{ active: $route.path === dashboardRoute }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-tachometer-alt"></i>
      <span class="menu-text ms-1">{{ $t('sidebar.dashboard') }}</span>
    </router-link>
  </li>
              <li class="nav-item" v-if="can('statistics.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'academic-statistics' }"
                  :class="{ active: $route.name === 'satistics.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-chart-bar"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.statistics") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('classes.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'classes.index' }"
                  :class="{ active: $route.name === 'classes.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-chalkboard-teacher"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.classes") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('teachers.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'teachers.index' }"
                  :class="{ active: $route.name === 'teachers.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-person-chalkboard"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.teachers") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('employees.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'employees.index' }"
                  :class="{ active: $route.name === 'employees.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-user-tie"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.employees") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('teacher_lessons.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'teacher-lessons.index' }"
                  :class="{ active: $route.name === 'teacher-lessons.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-chalkboard-user"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.teacher_lessons") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('subjects.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'subjects.index' }"
                  :class="{ active: $route.name === 'subjects.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-book-open"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.subjects") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('exam_gate_schedules.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'exams.management' }"
                  :class="{ active: $route.name === 'exam-schedules.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar-days"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.exams") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('grade_sheets.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'grade-sheets.index' }"
                  :class="{ active: $route.name === 'grade-sheets.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-file-alt"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.grades") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('announcements.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'announcements.index' }"
                  :class="{ active: $route.name === 'announcements.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-bullhorn"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.announcements") }}</span>
                </router-link>
              </li>
<li class="nav-item" >
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>

              <div class="nav-item" v-if="hasAny(['teacher_attendance.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('attendance') }"
                  href="#"
                  @click.prevent="toggleMenu('attendance')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-calendar-check ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.teacher_attendance") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'attendance' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'attendance' }">
                  <router-link
                    v-if="can('teacher_attendance.display')"
                    to="/teacher-attendances"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-chalkboard-teacher ms-2"></i>
                    {{ $t("sidebar.teacher_attendance") }}
                  </router-link>
                </div>
              </div>

              <div class="nav-item" v-if="hasAny(['questions.display','exam_forms.create'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('questions') }"
                  href="#"
                  @click.prevent="toggleMenu('questions')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-question-circle ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.questions_management") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'questions' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'questions' }">
                  <router-link
                    v-if="can('questions.display')"
                    :to="{ name: 'questions.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('questions') }"
                  >
                    <i class="fas fa-list ms-2"></i>
                    {{ $t("sidebar.questions") }}
                  </router-link>

                  <router-link
                    v-if="can('exam_forms.create')"
                    :to="{ name: 'question-forms.create' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('question-forms') }"
                  >
                    <i class="fas fa-file-alt ms-2"></i>
                    {{ $t("sidebar.exam_forms") }}
                  </router-link>
                </div>
              </div>

              <div class="nav-item" v-if="hasAny(['groups.display','chapters.display','job_titles.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('settings') }"
                  href="#"
                  @click.prevent="toggleMenu('settings')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-cog ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("navbar.settings") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'settings' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'settings' }">
                  <router-link
                    v-if="can('groups.display')"
                    to="/groups"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-users ms-2"></i>
                    {{ $t("sidebar.groups_management") }}
                  </router-link>

                  <router-link
                    v-if="can('chapters.display')"
                    class="dropdown-item"
                    :to="{ name: 'chapters.index' }"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fa-solid fa-list-ol ms-2"></i>
                    {{ $t("sidebar.chapters_management") }}
                  </router-link>

                  <router-link
                    v-if="can('job_titles.display')"
                    :to="{ name: 'job-titles.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'job-titles.index' }"
                  >
                    <i class="fa-solid fa-id-badge ms-2"></i>
                    {{ $t("sidebar.job_titles") }}
                  </router-link>
                </div>
              </div>
            </template>

            <!-- ===================== Student Affairs ===================== -->
            <template v-if="isStudentAffairs">
             <li class="nav-item" v-if="showDashboardMenu">
    <router-link
      class="nav-link"
      :to="dashboardRoute"
      :class="{ active: $route.path === dashboardRoute }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-tachometer-alt"></i>
      <span class="menu-text ms-1">{{ $t('sidebar.dashboard') }}</span>
    </router-link>
  </li>

              <li class="nav-item" v-if="can('statistics.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'student-affairs-statistics' }"
                  :class="{ active: $route.name === 'satistics.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-chart-bar"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.statistics") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('classes.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'classes.index' }"
                  :class="{ active: $route.name === 'classes.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-chalkboard-teacher"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.classes") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('students.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'students.index' }"
                  :class="{ active: $route.name === 'students.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-user-graduate"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.students") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('guardians.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'guardians.index' }"
                  :class="{ active: $route.name === 'guardians.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fa-solid fa-hands-holding-child"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.guardians") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('announcements.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'announcements.index' }"
                  :class="{ active: $route.name === 'announcements.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-bullhorn"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.announcements") }}</span>
                </router-link>
              </li>
<li class="nav-item" >
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>

              <div class="nav-item" v-if="hasAny(['student_attendance.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('attendance') }"
                  href="#"
                  @click.prevent="toggleMenu('attendance')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-calendar-check ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.student_attendance") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'attendance' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'attendance' }">
                  <router-link
                    v-if="can('student_attendance.display')"
                    to="/attendances"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-user-graduate ms-2"></i>
                    {{ $t("sidebar.student_attendance") }}
                  </router-link>
                </div>
              </div>
            </template>

            <!-- ===================== Finance ===================== -->
            <template v-if="isFinance">
               <li class="nav-item" v-if="showDashboardMenu">
    <router-link
      class="nav-link"
      :to="dashboardRoute"
      :class="{ active: $route.path === dashboardRoute }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-tachometer-alt"></i>
      <span class="menu-text ms-1">{{ $t('sidebar.dashboard') }}</span>
    </router-link>
  </li>
              <div
                class="nav-item"
                v-if="hasAny(['class_fees.display','financial_settings.display','financial_statements.display','payment_receipts.display'])"
              >
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('payments') }"
                  href="#"
                  @click.prevent="toggleMenu('payments')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-money-bill-wave ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.payments") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'payments' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>


                <div class="submenu" :class="{ show: activeMenu === 'payments' }">
                  <router-link
                    v-if="can('class_fees.display')"
                    :to="{ name: 'class-fees.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('class-fees') }"
                  >
                    <i class="fas fa-list-ul ms-2"></i>
                    {{ $t("sidebar.payment_structure") }}
                  </router-link>

                  <router-link
                    v-if="can('financial_settings.display')"
                    to="/financial-settings"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-money-bill-wave ms-2"></i>
                    {{ $t("sidebar.financial_settings") }}
                  </router-link>

                  <router-link
                    v-if="can('financial_statements.display')"
                    class="dropdown-item"
                    :to="{ name: 'financial.statements' }"
                    :class="{ active: $route.name?.startsWith('financial.statements') }"
                    @click="mobileSidebarOpen = false"
                  >
                    <i class="fas fa-file-invoice-dollar ms-2"></i>
                    {{ $t("sidebar.statements") }}
                  </router-link>

                  <router-link
                    v-if="can('payment_receipts.display')"
                    :to="{ name: 'payment-receipts.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('payment-receipts') }"
                  >
                    <i class="fas fa-exchange-alt ms-2"></i>
                    {{ $t("sidebar.payment_transactions") }}
                  </router-link>
                  
                </div>
              </div>

              <div class="nav-item" v-if="hasAny(['salary_management.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('salaries') }"
                  href="#"
                  @click.prevent="toggleMenu('salaries')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fa-solid fa-sack-dollar ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.salaries") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'salaries' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'salaries' }">
                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.dashboard' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.dashboard' }"
                  >
                    <i class="fa-solid fa-chart-pie me-1"></i>
                    {{ $t("sidebar.salary_dashboard") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.management' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.management' || $route.name === 'salary.receipts' }"
                  >
                    <i class="fa-solid fa-money-check-dollar me-1"></i>
                    {{ $t("sidebar.salary_receipts") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.calculations' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.calculations' || $route.name === 'salary.calculationDetail' }"
                  >
                    <i class="fa-solid fa-calculator me-1"></i>
                    {{ $t("sidebar.salary_calculations") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.statements' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.statements' }"
                  >
                    <i class="fas fa-file-invoice-dollar me-1"></i>
                    {{ $t("sidebar.salary_statements") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.rewardsList' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.rewardsList' || $route.name === 'salaries.createReward' }"
                  >
                    <i class="fas fa-gift me-1"></i>
                    {{ $t("sidebar.salary_rewards") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.deductionsList' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.deductionsList' || $route.name === 'salaries.createDeduction' }"
                  >
                    <i class="fas fa-circle-minus me-1"></i>
                    {{ $t("sidebar.salary_deductions") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.employeeSheet' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.employeeSheet' }"
                  >
                    <i class="fas fa-file-invoice me-1"></i>
                    {{ $t("sidebar.salary_employee_sheet") }}
                  </router-link>

                  <router-link
                    v-if="can('salary_management.display')"
                    :to="{ name: 'salary.teacherSheet' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name === 'salary.teacherSheet' }"
                  >
                    <i class="fas fa-chalkboard-teacher me-1"></i>
                    {{ $t("sidebar.salary_teacher_sheet") }}
                  </router-link>
                </div>
              </div>
              <li class="nav-item" >
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>
            </template>

            <!-- ===================== Teacher ===================== -->
            <template v-if="isTeacher">
                  <li class="nav-item" v-if="showDashboardMenu">
    <router-link
      class="nav-link"
      :to="dashboardRoute"
      :class="{ active: $route.path === dashboardRoute }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-tachometer-alt"></i>
      <span class="menu-text ms-1">{{ $t('sidebar.dashboard') }}</span>
    </router-link>
  </li>

              <li class="nav-item" v-if="can('class_schedules.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'teacher.schedule' }"
                  :class="{ active: $route.name === 'teacher.schedule' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.my_schedule") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('assignments.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'assignments.index' }"
                  :class="{ active: $route.name === 'assignments.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-tasks"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.assignments") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('exam_gate_schedules.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'exams.management' }"
                  :class="{ active: $route.name === 'exams.management' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar-days"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.exams") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('student_attendance.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'attendances' }"
                  :class="{ active: $route.name === 'attendences' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar-check"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.student_attendance") }}</span>
                </router-link>
              </li>

              <div class="nav-item" v-if="hasAny(['questions.display','exam_forms.create'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('questions') }"
                  href="#"
                  @click.prevent="toggleMenu('questions')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-question-circle ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.questions") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'questions' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>


                <div class="submenu" :class="{ show: activeMenu === 'questions' }">
                  <router-link
                    v-if="can('questions.display')"
                    :to="{ name: 'questions.index' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('questions') }"
                  >
                    <i class="fas fa-list ms-2"></i>
                    {{ $t("sidebar.questions_bank") }}
                  </router-link>

                  <router-link
                    v-if="can('exam_forms.create')"
                    :to="{ name: 'question-forms.create' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('question-forms') }"
                  >
                    <i class="fas fa-file-alt ms-2"></i>
                    {{ $t("sidebar.exam_forms") }}
                  </router-link>
                </div>

              </div>

              <li class="nav-item" v-if="can('grade_sheets.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'grade-sheets.index' }"
                  :class="{ active: $route.name === 'grade-sheets.index' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-file-alt"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.grades") }}</span>
                </router-link>
              </li>
              
              <li class="nav-item">
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>
            </template>

            <!-- ===================== Student ===================== -->
            <template v-if="isStudent">
                  <li class="nav-item" v-if="showDashboardMenu">
    <router-link
      class="nav-link"
      :to="dashboardRoute"
      :class="{ active: $route.path === dashboardRoute }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-tachometer-alt"></i>
      <span class="menu-text ms-1">{{ $t('sidebar.dashboard') }}</span>
    </router-link>
  </li>
              <li class="nav-item" v-if="can('class_schedules.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'student.schedule' }"
                  :class="{ active: $route.name === 'student.schedule' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.my_schedule") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('student_assignments.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'student.assignments' }"
                  :class="{ active: $route.name === 'student.assignments' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-tasks"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.my_assignments") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('student_attendance.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'student.attendances' }"
                  :class="{ active: $route.name === 'student.attendances' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar-check"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.my_attendance") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('student_grades.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'student.grades' }"
                  :class="{ active: $route.name === 'student.grades' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-file-alt"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.my_grades") }}</span>
                </router-link>
              </li>
              <li class="nav-item" >
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>

            </template>

            <!-- ===================== Canteen Role ===================== -->
            <template v-if="isCanteen">
              <div class="nav-item" v-if="can('canteen_transactions.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'canteen.dashboard' }"
                  :class="{ active: $route.name === 'canteen.dashboard' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-cash-register"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.canteen_dashboard") }}</span>
                </router-link>
              </div>

              <div class="nav-item" v-if="hasAny(['canteen_products.display'])">
                <a
                  class="nav-link d-flex justify-content-between align-items-center"
                  :class="{ active: isMenuActive('canteen') }"
                  href="#"
                  @click.prevent="toggleMenu('canteen')"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-utensils ms-2"></i>
                    <span class="menu-text ms-1">{{ $t("sidebar.canteen") }}</span>
                  </span>
                  <i class="fas" :class="activeMenu === 'canteen' ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </a>

                <div class="submenu" :class="{ show: activeMenu === 'canteen' }">
                  <router-link
                    v-if="can('canteen_products.display')"
                    :to="{ name: 'canteen.products' }"
                    class="dropdown-item"
                    @click="mobileSidebarOpen = false"
                    :class="{ active: $route.name?.startsWith('canteen.products') }"
                  >
                    <i class="fas fa-box me-1"></i>
                    {{ $t("canteen.products") }}
                  </router-link>
                </div>
                          <li class="nav-item" >
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>
              </div>
            </template>

            <!-- ===================== Guardian ===================== -->
            <template v-if="isGuardian">
                 <li class="nav-item" v-if="showDashboardMenu">
    <router-link
      class="nav-link"
      :to="dashboardRoute"
      :class="{ active: $route.path === dashboardRoute }"
      @click="mobileSidebarOpen = false"
    >
      <i class="fas fa-tachometer-alt"></i>
      <span class="menu-text ms-1">{{ $t('sidebar.dashboard') }}</span>
    </router-link>
  </li>
              <li class="nav-item" v-if="can('class_schedules.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'guardian.schedule' }"
                  :class="{ active: $route.name === 'guardian.schedule' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.children_schedule") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('student_attendance.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'attendances' }"
                  :class="{ active: $route.name === 'attendances' }"
                  @click="mobileSidebarOpen = false"
                >
                  <i class="fas fa-calendar-check"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.children_attendance") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-if="can('guardian_students.display')">
                <router-link
                  class="nav-link"
                  :to="{ name: 'guardians.students.payments', params: { id: currentUser?.id } }"
                  :class="{ active: $route.name === 'guardians.students.payments' }"
                  @click="goAndReload"
                >
                  <i class="fas fa-money-bill-wave"></i>
                  <span class="menu-text ms-1">{{ $t("sidebar.guardian_students") }}</span>
                </router-link>
              </li>
                        <li class="nav-item" >
  <router-link class="nav-link" :to="{ name: 'messages' }" @click="mobileSidebarOpen = false">
    <i class="fas fa-comments"></i>
    <span class="menu-text ms-1">{{ $t("sidebar.chat") }}</span>
    <span v-if="unreadCount > 0" class="badge bg-danger ms-1">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </router-link>
</li>
            </template>
          </ul>
        </div>

        <div class="sidebar-footer">
  <div class="user-info">
    <img
      :alt="$t('navbar.profile')"
      :src="getAvatarUrl(currentUser)"
      class="user-avatar"
      @error="handleImageError"
    />
    <div class="user-details">
      <span class="user-name">{{ userName }}</span>
      <span class="user-role">{{ userRole }}</span>
    </div>
  </div>
  <button class="profile-btn" @click="goToProfile">
    <i class="fas fa-id-card me-2"></i>
    <span>{{ $t("sidebar.profile") }}</span>
  </button>
  <button class="logout-btn" @click="logout">
    <i class="fas fa-sign-out-alt me-2"></i>
    <span>{{ $t("navbar.logout") }}</span>
  </button>
</div>
      </div>
    </div>
    
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Cookies from "js-cookie";
import { useI18n } from "vue-i18n";
import api from "@/api";

import { initEcho } from "../../../resources/js/echo.js";

const { locale } = useI18n();
const store = useStore();
const router = useRouter();
const route = useRoute();

const mobileSidebarOpen = ref(false);
const activeMenu = ref(null);
const unreadCount = ref(0);
const userChannel = ref("");

const teacherDetails = ref(null);
const studentDetails = ref(null);
const guardianDetails = ref(null);

const currentUser = computed(() => {
  if (store.state.user) return store.state.user;
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
});

// Role detection
const userRoleSlug = computed(() => {
  const fromStore = store.state.user?.role?.slug;
  if (fromStore) return fromStore;

  try {
    const fromLocal = JSON.parse(localStorage.getItem("user"))?.role?.slug;
    if (fromLocal) return fromLocal;
  } catch {
    // ignore
  }

  return Cookies.get("user_type");
});

const isTeacher = computed(() => userRoleSlug.value === 'teacher');
const isStudent = computed(() => userRoleSlug.value === 'student');
const isGuardian = computed(() => userRoleSlug.value === 'guardian');

// ===== FUNCTIONS =====
const isSuperAdmin = computed(() => {
  const role = userRoleSlug.value;
  return role === 'super_admin';
});

const toggleMobileSidebar = () => {
  mobileSidebarOpen.value = !mobileSidebarOpen.value;
};

const resolveBackendOrigin = () => {
  try {
    if (import.meta.env && import.meta.env.VITE_API_BASE_URL) {
      const url = import.meta.env.VITE_API_BASE_URL;
      try {
        return new URL(url).origin;
      } catch {
        return url.replace(/\/+$/, '');
      }
    }
  } catch (e) {
    console.warn('Error accessing import.meta.env', e);
  }

  const { protocol, hostname, port } = window.location;
  if (port === '8080' || port === '5173' || port === '3000') {
    return `${protocol}//${hostname}:8000`;
  }
  
  return window.location.origin;
};

const BACKEND_ORIGIN = resolveBackendOrigin();

const joinUrl = (origin, path) => {
  return `${String(origin).replace(/\/+$/, '')}/${String(path || '').replace(/^\/+/, '')}`;
};

const isRouteActive = (names = [], paths = []) => {
  const routeName = String(route.name || "");
  const routePath = String(route.path || "");

  const matchedName = names.some((name) => {
    if (!name) return false;
    if (name.endsWith(".")) {
      return routeName.startsWith(name);
    }
    return routeName === name || routeName.startsWith(`${name}.`);
  });

  const matchedPath = paths.some((path) => {
    if (!path) return false;
    return routePath === path || routePath.startsWith(path);
  });

  return matchedName || matchedPath;
};

const isMenuActive = (menu) => {
  const map = {
    rewards: () => isRouteActive(["student-rewards.index", "student-rewards.statistics"]),
    canteen: () => isRouteActive(["canteen.dashboard", "canteen.products"], ["/canteen", "/canteen/products"]),
    attendance: () => isRouteActive(["attendances", "teacher-attendances", "student.attendances"], ["/attendances", "/teacher-attendances"]),
    questions: () => isRouteActive(["questions.", "question-forms."]),
    payments: () => isRouteActive(
      ["class-fees", "payment-receipts", "financial.statements", "financial.settings", "settings.financial"],
      ["/class-fees", "/payment-receipts", "/financial-settings", "/financial-statements"]
    ),
    accountStatements: () => isRouteActive([
      "reports.guardianAccountStatement",
      "reports.guardianWalletStatement",
      "reports.studentAccountStatement",
      "reports.studentWalletStatement",
    ]),
    salaries: () => isRouteActive(["salary.dashboard", "salary.management", "salary.receipts", "salary.statements", "salary.calculations", "salary.calculationDetail", "salaries.createReward", "salaries.createDeduction", "salary.rewardsList", "salary.deductionsList", "salary.employeeSheet", "salary.teacherSheet"]),
    academic: () => isRouteActive(["academic.years", "academic.promotion", "academic.promotion-history"]),
    settings: () => isRouteActive(
      ["settings.nationalities", "chapters", "settings.exam-types", "settings.reward-points.index", "job-titles.index"],
      ["/groups", "/settings/areas", "/settings/reward-points"]
    ),
  };

  return map[menu] ? map[menu]() : false;
};

const syncActiveMenuWithRoute = () => {
  const menus = ["rewards", "canteen", "attendance", "questions", "payments", "accountStatements", "salaries", "academic", "settings"];
  const matchedMenu = menus.find((menu) => isMenuActive(menu));
  activeMenu.value = matchedMenu || null;
};

const fetchTeacherDetails = async (teacherId) => {
  try {
    const response = await api.get(`/teachers/${teacherId}`);
    teacherDetails.value = response.data.data;
  } catch (error) {
    console.error('Error fetching teacher details:', error);
  }
};

const fetchStudentDetails = async (studentId) => {
  try {
    const response = await api.get(`/students/${studentId}`);
    studentDetails.value = response.data.data;
  } catch (error) {
    console.error('Error fetching student details:', error);
  }
};

const fetchGuardianDetails = async (guardianId) => {
  try {
    const response = await api.get(`/guardians/${guardianId}`);
    guardianDetails.value = response.data.data;
  } catch (error) {
    console.error('Error fetching guardian details:', error);
  }
};

const getAvatarUrl = (user) => {
  if (!user) return '/images/default-avatar.png';
  
  const baseUrl = BACKEND_ORIGIN;
  
  if (isTeacher.value && teacherDetails.value) {
    if (teacherDetails.value.image_url) {
      return teacherDetails.value.image_url.startsWith('http')
        ? teacherDetails.value.image_url
        : joinUrl(baseUrl, teacherDetails.value.image_url);
    }
    if (teacherDetails.value.image) {
      const path = teacherDetails.value.image.replace(/^\/+/, '');
      return joinUrl(baseUrl, path.startsWith('storage/') ? path : `storage/${path}`);
    }
  }
  
  if (isStudent.value && studentDetails.value) {
    if (studentDetails.value.image_url) {
      return studentDetails.value.image_url.startsWith('http')
        ? studentDetails.value.image_url
        : joinUrl(baseUrl, studentDetails.value.image_url);
    }
    if (studentDetails.value.image) {
      const path = studentDetails.value.image.replace(/^\/+/, '');
      return joinUrl(baseUrl, path.startsWith('storage/') ? path : `storage/${path}`);
    }
  }
  
  if (isGuardian.value && guardianDetails.value) {
    if (guardianDetails.value.avatar_url) {
      return guardianDetails.value.avatar_url.startsWith('http')
        ? guardianDetails.value.avatar_url
        : joinUrl(baseUrl, guardianDetails.value.avatar_url);
    }
    if (guardianDetails.value.avatar) {
      const path = guardianDetails.value.avatar.replace(/^\/+/, '');
      return joinUrl(baseUrl, path.startsWith('storage/') ? path : `storage/${path}`);
    }
  }
  
  if (user.avatar_url) {
    return user.avatar_url.startsWith('http') 
      ? user.avatar_url 
      : joinUrl(baseUrl, user.avatar_url);
  }
  
  if (user.avatar) {
    const path = user.avatar.replace(/^\/+/, '');
    return joinUrl(baseUrl, path.startsWith('storage/') ? path : `storage/${path}`);
  }
  
  if (user.image_url) {
    return user.image_url.startsWith('http')
      ? user.image_url
      : joinUrl(baseUrl, user.image_url);
  }
  
  if (user.image) {
    const path = user.image.replace(/^\/+/, '');
    return joinUrl(baseUrl, path.startsWith('storage/') ? path : `storage/${path}`);
  }
  
  return '/images/default-avatar.png';
};

const handleImageError = (e) => {
  e.target.src = '/images/default-avatar.png';
};

const toggleMenu = (menuName) => {
  activeMenu.value = activeMenu.value === menuName ? null : menuName;
};

const goAndReload = () => {
  mobileSidebarOpen.value = false;
  setTimeout(() => window.location.reload(), 200);
};

const logout = async () => {
  try {
    await store.dispatch("logoutUser");
    mobileSidebarOpen.value = false;
    router.push("/login");
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

const can = (slug) => store.getters?.can?.(slug) === true;
const hasAny = (slugs = []) => slugs.some((s) => can(s));

const goToProfile = () => {
  mobileSidebarOpen.value = false;
  router.push('/profile');
};

const isSchoolAdmin = computed(() => userRoleSlug.value === "school_admin");
const isAcademicManager = computed(() => userRoleSlug.value === "academic_manager");
const isFinance = computed(() => userRoleSlug.value === "finance");
const isStudentAffairs = computed(() => userRoleSlug.value === "student_affairs");
const isCanteen = computed(() => userRoleSlug.value === "canteen");
const permissionsReady = computed(() => store.state.permissionsReady === true);

const dashboardRoute = computed(() => {
  if (isSuperAdmin.value) return "/admin/dashboard";
  if (isSchoolAdmin.value) return "/admin/dashboard";
  if (isAcademicManager.value) return "/academic/dashboard";
  if (isStudentAffairs.value) return "/student-affairs/dashboard";
  if (isTeacher.value) return "/teacher/dashboard";
  if (isStudent.value) return "/student/dashboard";
  if (isGuardian.value) return "/guardian/dashboard";

  if (isFinance.value) {
    const financeRoutes = [
      { perm: "class_fees.display", name: "class-fees" },
      { perm: "financial_settings.display", name: "financial.settings" },
      { perm: "financial_statements.display", name: "financial.statements" },
      { perm: "payment_receipts.display", name: "payment-receipts.index" },
      { perm: "salary_management.display", name: "salary.management" },
    ];

    const first = financeRoutes.find((r) => can(r.perm));
    return first ? { name: first.name } : { name: "unauthorized" };
  }

  if (isCanteen.value) {
    if (can("canteen_transactions.display")) return "/canteen";
    if (can("canteen_products.display")) return "/canteen/products";
    return "/unauthorized";
  }

  return "/unauthorized";
});
const roleTranslations = {
  school_admin: "مدير النظام",
  academic_manager: "مسؤول أكاديمي",
  student_affairs: "شؤون الطلاب",
  teacher: "معلم",
  student: "طالب",
  canteen: "المقصف",
  finance: "المالية",
  guardian: "ولي أمر",
};

const userName = computed(() => {
  if (currentUser.value) {
    if (isTeacher.value && teacherDetails.value) {
      return teacherDetails.value.username || currentUser.value.username || currentUser.value.name || '';
    }
    
    if (isStudent.value && studentDetails.value) {
      if (studentDetails.value.full_name) return studentDetails.value.full_name;
      const firstName = studentDetails.value.first_name || '';
      const fatherName = studentDetails.value.father_name || '';
      const lastName = studentDetails.value.last_name || '';
      const fullName = `${firstName} ${fatherName} ${lastName}`.trim();
      if (fullName) return fullName;
    }
    
    if (isGuardian.value && guardianDetails.value) {
      return guardianDetails.value.name || currentUser.value.name || currentUser.value.username || '';
    }
    
    if (currentUser.value.name) return currentUser.value.name;
    if (currentUser.value.username) return currentUser.value.username;
    if (currentUser.value.first_name && currentUser.value.last_name) {
      return `${currentUser.value.first_name} ${currentUser.value.last_name}`;
    }
  }
  const cookieName = Cookies.get("user_name");
  if (cookieName) return decodeURIComponent(cookieName);
  return locale.value === "ar" ? "مستخدم" : "User";
});

const userRole = computed(() => {
  const role = userRoleSlug.value;
  return roleTranslations[role] || role || "دور المستخدم";
});

const showDashboardMenu = computed(() => {
  const role = userRoleSlug.value;
  if (role === "finance" || role === "canteen") return false;

  const need = {
    school_admin: "admin_dashboard.display",
    academic_manager: "academic_dashboard.display",
    student_affairs: "student_affairs_dashboard.display",
  }[role];

  return !need || can(need);
});

const showPostsMenu = computed(() => {
  const role = userRoleSlug.value;
  return ["school_admin", "academic_manager", "student_affairs", "teacher"].includes(role) && can("posts.display");
});

// ===== WATCHERS =====
watch(currentUser, async (newUser) => {
  if (newUser?.id) {
    if (isTeacher.value) {
      await fetchTeacherDetails(newUser.id);
    } else if (isStudent.value) {
      await fetchStudentDetails(newUser.id);
    } else if (isGuardian.value) {
      await fetchGuardianDetails(newUser.id);
    }
  }
}, { immediate: true });

watch(
  () => [route.name, route.path],
  () => {
    syncActiveMenuWithRoute();
  },
  { immediate: true }
);

// ===== CHAT FUNCTIONS =====
const myId = () => Number(store.state.user?.id || 0);
const myType = () => String(store.state.user?.type || "User");

const ensureEcho = () => {
  if (!window.Echo) initEcho();
  return !!window.Echo;
};

const leaveChannel = (name) => {
  if (!name) return;
  try {
    window.Echo?.leave(name);
  } catch {
    // ignore
  }
};

const recomputeUnread = (conversations = []) => {
  unreadCount.value = conversations.reduce((sum, c) => sum + (Number(c.unread_count) || 0), 0);
};

const loadUnreadOnce = async () => {
  try {
    const res = await api.get("/chat");
    const conversations = res.data?.conversations || [];
    recomputeUnread(conversations);
  } catch {
    // ignore (badge will still update from realtime)
  }
};

const incrementUnreadSafe = () => {
  if (route.name === "messages" || route.path === "/messages") return;
  unreadCount.value = Math.min(99, (Number(unreadCount.value) || 0) + 1);
};

const setupChatBadgeRealtime = () => {
  if (!ensureEcho()) return;

  const id = myId();
  const type = myType();
  if (!id || !type) return;

  const name = `user.${type}.${id}`;
  if (userChannel.value && userChannel.value !== name) leaveChannel(userChannel.value);
  userChannel.value = name;

  const ch = window.Echo.private(name);

  ch.listen(".inbox.message", () => {
    incrementUnreadSafe();
  });

  ch.listen(".conversation.created", () => {
    loadUnreadOnce();
  });
};

// ===== WATCHERS =====
watch(
  () => route.name || route.path,
  (v) => {
    if (v === "messages" || v === "/messages") unreadCount.value = 0;
  },
  { immediate: true }
);

// ===== LIFECYCLE HOOKS =====
onMounted(() => {
  syncActiveMenuWithRoute();
  loadUnreadOnce();
  setupChatBadgeRealtime();
});

onUnmounted(() => {
  if (userChannel.value) leaveChannel(userChannel.value);
});
</script>

<style scoped>
.hamburger-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #333;

  direction: locale;
}

@media (min-width: 992px) {
  .hamburger-btn {
    display: none;
  }
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
}

.sidebar-overlay.active {
  opacity: 1;
  visibility: visible;
}

@media (min-width: 992px) {
  .sidebar-overlay {
    display: none;
  }
}

.sidebar {
  width: 280px;
  height: 100vh;
  position: fixed;
  top: 0;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.sidebar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

@media (max-width: 991.98px) {
  .sidebar {
    transform: translateX(100%);
  }

  .sidebar.mobile-open {
    transform: translateX(0);
  }
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.sidebar-brand {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 30px;
  height: 30px;
  margin-left: 10px;
  object-fit: contain;
}

.brand-text {
  font-weight: bold;
  font-size: 1.25rem;
}

.sidebar-menu {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px 0;
}

.nav {
  padding-right: 0;
  list-style: none;
}
.nav-item {
  margin-bottom: 5px;
}

.nav-link {
  color: #555;
  font-weight: 500;
  padding: 12px 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.nav-link:hover {
  background-color: #f8f9fa;
  color: #2c91ae;
}

.nav-link.active,
.nav-link.router-link-active,
.nav-link.router-link-exact-active {
  background: #f0f7ff;
  color: #2c91ae;
}

.nav-link i {
  margin-left: 10px;
  width: 20px;
  text-align: center;
}

.nav-link.active i,
.nav-link.router-link-active i,
.nav-link.router-link-exact-active i {
  color: #2c91ae;
}

.sidebar-footer {
  padding: 15px;
  border-top: 1px solid #eee;
}

.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 10px;
  object-fit: cover;
  border: 2px solid #f0f0f0;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 600;
  font-size: 0.9rem;
}

.user-role {
  font-size: 0.8rem;
  color: #777;
}

.logout-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #555;
  padding: 8px 15px;
  width: 100%;
  border-radius: 4px;
  transition: all 0.2s;
}

.logout-btn:hover {
  background: #f5f5f5;
  color: #d32f2f;
}

.logout-btn i {
  margin-left: 8px;
}

.submenu {
  padding-left: 20px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.submenu.show {
  max-height: 500px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  color: #495057;
  text-decoration: none;
  transition: all 0.2s;
  border-radius: 5px;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  color: #2c91ae;
}

.dropdown-item.active,
.dropdown-item.router-link-active,
.dropdown-item.router-link-exact-active {
  background: #f0f7ff;
  color: #2c91ae;
  font-weight: 600;
}

.dropdown-item i {
  width: 20px;
  text-align: center;
}

.dropdown-item.active i,
.dropdown-item.router-link-active i,
.dropdown-item.router-link-exact-active i {
  color: #2c91ae;
}

.submenu-enter-active,
.submenu-leave-active {
  transition: max-height 0.3s ease;
}
.submenu-enter-from,
.submenu-leave-to {
  max-height: 0;
}
.submenu-enter-to,
.submenu-leave-from {
  max-height: 200px;
}
.sidebar {
  width: 280px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  transition: transform 0.3s ease;
}

[dir="rtl"] .sidebar {
  left: auto;
  right: 0;
}

[dir="ltr"] .sidebar {
  left: 0;
  right: auto;
  transform: translateX(-100%);
}
[dir="ltr"] .hamburger-btn {
  left: 15px;
  right: auto;
}
.sidebar.mobile-open {
  transform: translateX(0) !important;
}

@media (min-width: 992px) {
  .sidebar {
    transform: translateX(0) !important;
  }
}
.sidebar {
  width: 280px;
  position: fixed;
  top: 0;
  bottom: 0; 
  height: auto; 
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.sidebar-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-menu {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-footer {
  margin-top: auto;
}
.profile-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #555;
  padding: 8px 15px;
  width: 100%;
  border-radius: 4px;
  transition: all 0.2s;
  margin-bottom: 5px;
}

.profile-btn:hover {
  background: #f5f5f5;
  color: #2c91ae;
}

.profile-btn i {
  margin-left: 8px;
}
</style>